export const isApplePayAvailable = () => {
  return (
    window.PaymentRequest &&
    window.ApplePaySession &&
    window.ApplePaySession.canMakePayments &&
    window.ApplePaySession.canMakePayments()
  );
};
